import { IconName } from "react-frontier-v2";

export const ICON_NAMES: IconName[] = [
   'laptop',
   'hard-drive',
   'hdd',
   'floppy-disk',
   'save',
   'keyboard',
   'mobile-screen-button',
   'mobile-alt',
   'mobile-screen',
   'mobile-android-alt',
   'tablet',
   'tablet-android',
   'desktop',
   'desktop-alt',
   'laptop-house',
   'laptop-file',
   'blender-phone',
   'mouse',
   'ticket',
   'bug',
   'wrench',
   'gear',
   'bell',
   'circle-exclamation',
   'file-lines',
   'list',
   'tag',
   'user',
   'phone',
   'envelope',
   'credit-card',
   'calendar',
   'clock',
   'lock',
   'star',
   'question',
];

export const ISSUE_ICON_NAMES: { value: IconName; text: string }[] = [
   { value: 'ticket-alt', text: 'Ticket' },
   { value: 'bug', text: 'Bug / Error' },
   { value: 'wrench', text: 'Mantenimiento' },
   { value: 'gear', text: 'Configuración' },
   { value: 'laptop', text: 'Laptop' },
   { value: 'hard-drive', text: 'Hardware' },
   { value: 'bell', text: 'Alerta / Aviso' },
   { value: 'circle-exclamation', text: 'Urgente' },
   { value: 'file-lines', text: 'Documentación' },
   { value: 'list', text: 'Lista de tareas' },
   { value: 'tag', text: 'Etiqueta' },
   { value: 'user', text: 'Usuario / Cuenta' },
   { value: 'phone', text: 'Telefonía' },
   { value: 'envelope', text: 'Correo' },
   { value: 'credit-card', text: 'Pagos' },
   { value: 'calendar', text: 'Calendario / Fechas' },
   { value: 'clock', text: 'Tiempos / Horarios' },
   { value: 'lock', text: 'Seguridad' },
   { value: 'star', text: 'Especial' },
   { value: 'question', text: 'Duda / Pregunta' },
];